import { Stack, Typography, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";

import { Strings } from "@app/constants";
import { useResponsive } from "@app/hooks";
import { CarSearchBar } from "./cars-search-bar";

const HeroBanner = () => {
  const isTab = useResponsive("down", "md");
  const isMobile = useResponsive("down", "sm");
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Stack
      position="absolute"
      width="100%"
      height={"100%"}
      alignItems={"center"}
      justifyContent={"center"}
      flexDirection={isMobile ? "column-reverse" : "row"}
      px={2}
    >
      <Stack
        flex={1}
        mb={isMobile ? 4 : 0}
        sx={{
          justifyContent: "center",
        }}
      >
        <CarSearchBar />
      </Stack>
      <Stack
        flex={1.4}
        pr={isTab ? 0 : 5}
        justifyContent={"center"}
        alignItems={"center"}
      >
        <Typography
          sx={{
            color: theme.palette.common.white,
            fontWeight: "bold",
            fontFamily: "Abril Fatface",
            fontSize: isTab ? 28 : 65,
            textAlign: "center",
            textShadow: `0px 2px 6px rgba(0, 0, 0, 0.6)`,
          }}
        >
          {Strings.home.findYourRide}
        </Typography>
      </Stack>
    </Stack>
  );
};

export { HeroBanner };
